/**
 * @generated SignedSource<<44aeda6ba2e9592bb2e36a00e5094f63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddPlayersHeaderNode$data = {
  readonly requirePlayerCounts?: boolean;
  readonly standardCapacity?: number;
  readonly usedCapacity?: number;
  readonly " $fragmentType": "AddPlayersHeaderNode";
};
export type AddPlayersHeaderNode$key = {
  readonly " $data"?: AddPlayersHeaderNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"AddPlayersHeaderNode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AddPlayersHeaderNode",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "requirePlayerCounts",
          "storageKey": null
        },
        {
          "alias": "standardCapacity",
          "args": [
            {
              "kind": "Literal",
              "name": "bookingType",
              "value": "STANDARD"
            }
          ],
          "kind": "ScalarField",
          "name": "capacity",
          "storageKey": "capacity(bookingType:\"STANDARD\")"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "usedCapacity",
          "storageKey": null
        }
      ],
      "type": "TimeSlot",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
};

(node as any).hash = "a1dac0ae2064cceaacb5a4ff85442416";

export default node;
